export default __webpack_public_path__ + "static/media/concluded_resumes.f5b077a2.png";